/**
 * Format an axios error's response detail into a safe string for
 * rendering. FastAPI returns either:
 *  - a string (custom HTTPException with a detail message), or
 *  - an array of validation objects on 422 (each with type/loc/msg/input)
 *
 * Rendering the array of objects directly throws React error #31
 * ("Objects are not valid as a React child") and blanks the page.
 * Always pipe error display through this.
 */
export function formatApiError(err: any, fallback: string = "Something went wrong"): string {
  const detail = err?.response?.data?.detail;
  if (typeof detail === "string") return detail;
  if (Array.isArray(detail)) {
    return detail
      .map((d: any) => d?.msg || JSON.stringify(d))
      .join("; ");
  }
  if (detail) return JSON.stringify(detail);
  if (err?.message) return err.message;
  return fallback;
}
